import { Link } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  infoAlert: {
    "& .MuiAlert-icon": {
      color: "#B8E7FB",
    },
    marginTop: "30px",
    backgroundColor: "#233145",
  },
})

type PropsType = {
  propertyName: string;
  propertyID: string;
}

const AlertChecklistEmpty: FC<PropsType> = ({propertyName, propertyID}) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Alert className={classes.infoAlert} severity="info">
      {t("CLP_noChecklist1")}
      <Link component={NavLink} exact to={`/standards/${propertyID}/classify`}>
        {t("CLP_noChecklist2")}
      {t("CLP_noChecklist3")}{" "}
      {propertyName}{" "}
      </Link>
      {t("CLP_noChecklist4")}
    </Alert>
  )
}

export default AlertChecklistEmpty
